import { Component, Input, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { Observable } from "rxjs";
import { DateRange } from "models/daterange/DateRange";
import { DateService } from "services/date/DateService";

@Component({
    selector: "ts-day-changer",
    templateUrl: "ts-day-changer.html",
    host: { "[class.c-ts-day-changer]": "true" },
})
export class TSDayChangerComponent implements OnInit {
    @Input() public isNextDayChanger: boolean;
    @Input() public userId: string;
    @Input() public dateRangeObservable: Observable<DateRange>;
    private to: Date;
    private from: Date;

    constructor(private router: Router) {}

    public ngOnInit() {
        this.dateRangeObservable.subscribe((dr: DateRange) => {
            this.to = dr.to;
            this.from = dr.from;
        });
    }

    public handleDayChange(isNextDayChanger: boolean) {
        if (isNextDayChanger) {
            this.from.setDate(this.from.getDate() + 1);
        } else {
            this.from.setDate(this.from.getDate() - 1);
        }

        const dateParams = {
            userId: this.userId,
            from: DateService.toISOString(this.from),
            to: DateService.toISOString(this.from),
        };

        this.router.navigate(["auth", "ts", dateParams]);
    }
}
